import React from 'react';
import { InfoIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { BannerWrapper } from './Banners.styles';

const CorporatePhoneBanner = () => {
  return (
    <Box bg="background" data-testid="CorporatePhoneBanner">
      <BannerWrapper backgroundColor="unseen">
        <InfoIcon width={16} height={16} />
        <Text size="normal">Call from employee phone.</Text>
      </BannerWrapper>
    </Box>
  );
};

export default CorporatePhoneBanner;
